import React, { useContext } from "react";

//global state
import { StateContext } from "../../AppStateContext";

//styling
import "./clusterRow.css";

//material ui
import TableCell from "@material-ui/core/TableCell";

const ClusterRowInfoId = ({ clusterInfo }) => {
  //consume global state
  const state = useContext(StateContext);

  return (
    <TableCell
      align="left"
      style={{
        borderBottom: state.theme === "dark" ? "1px solid #122742" : "1px solid #eaeaea",
      }}
    >
      {!clusterInfo.data.configuration.requiresAuthentication ? (
        <a href={`https://${clusterInfo.data.id}.weaviate.network`} target={`https://${clusterInfo.data.id}.weaviate.network`}>
          <p
            style={{
              overflowWrap: "break-word",
              color: "#b0a002",
            }}
            className={state.theme === "dark" ? "__tableCell __tableCellDark" : "__tableCell __tableCellLight"}
          >
            {clusterInfo.data.id}
          </p>
        </a>
      ) : (
        <p
          style={{
            overflowWrap: "break-word",
          }}
          className={state.theme === "dark" ? "__tableCell __tableCellDark" : "__tableCell __tableCellLight"}
        >
          {clusterInfo.data.id}
        </p>
      )}
    </TableCell>
  );
};

export default ClusterRowInfoId;
